export default "__VITE_ASSET__DlE4VyBf__"